import React, { Component } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { ConditionalPanel } from 'web-ui-components/lib/layout/content';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import OldAccountHolder from './components/OldAccountHolder';
import OldSortcode from './components/OldSortcode';
import OldAccountNumber from './components/OldAccountNumber';
import DebitCardQuestion from './components/DebitCardQuestion';
import CardNumber from './components/CardNumber';
import ExpiryDate from './components/ExpiryDate';

class OldAccountDetailsPage extends Component {
  render() {
    const { saveOldAccountDetailsForm, getBusinessData, isSoleTrader } = this.props;
    return (
      <Form
        onSubmit={saveOldAccountDetailsForm}
        initialValues={getBusinessData}
        render={({ handleSubmit, values }) => (
          <form onSubmit={handleSubmit}>
            <Content>
              {({
                oldAccountDetailsPageTitle = '',
                oldAccountDetailsPageTitleContent1,
                oldAccountDetailsPageTitleContent2
              }) => (
                <div>
                  <PageHeading>{oldAccountDetailsPageTitle}</PageHeading>
                  <StandardBody>
                    <p>{oldAccountDetailsPageTitleContent1}</p>
                    <p>{oldAccountDetailsPageTitleContent2}</p>
                  </StandardBody>
                  <OldAccountHolder />
                  <OldSortcode />
                  <OldAccountNumber />
                  {isSoleTrader && <DebitCardQuestion values={values} />}
                  {isSoleTrader && values.debitCardQuestion === 'Yes' && (
                    <ConditionalPanel isVisible>
                      <CardNumber />
                      <ExpiryDate />
                    </ConditionalPanel>
                  )}

                  <Submit hideExit submitButtonText="Confirm and continue" />
                </div>
              )}
            </Content>
          </form>
        )}
      />
    );
  }
}
OldAccountDetailsPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  saveOldAccountDetailsForm: PropTypes.func.isRequired
};

export default OldAccountDetailsPage;
